import Facade from '../../Facade';
import UIBehaviors from './UIBehaviors';
import Signals from '@/signals/GameSignals';
import GameStatesEnum from '@/states/GameStatesEnum';
import * as PIXI from 'pixi.js';
import Config from '@/config/Config';
import Platform from '@base/utils/Platform';
import ScaleManager from '@/stage/ScaleManager';
import FormatData from '@/application/FormatData';

export default class InterfaceManager {
	constructor() {
		new UIBehaviors();
		Facade.isSpaceToSpin = false;
		this.isMuted = false;
		this.gameEntered = false;
		this.soundValue = true;
		this.musicValue = true;
		this.blurFilter = new PIXI.filters.BlurFilter();
		this.blurFilter.blurX = 10;
		this.blurFilter.blurY = 10;
		this.blurFilter.autoFit = true;

		this.buttonClickSpeed = 100;
		this.addListeners();
	}

	show() {
		document.dispatchEvent(
			new CustomEvent('init', {
				detail: {
					safeFrame: ScaleManager.currentSizes.safe,
					container: Facade.mainContainer.uiContainer,
					menuContainer: Facade.mainContainer.uiMenuContainer,
					locale: Facade.locale,
					ctoken: Facade.model.casinoToken,
					showTime: true,
					soundChecked: true,
					musicChecked: true,
					volume: {
						visible: false,
					},
					home: {
						visible: Facade.model.lobbyURL ? true : false
					},
					notificationUrl: Facade.model.ns_url,
					notificationToken: Facade.model.chat,
					orientation: Facade.orientation,
					fullscreen: false,
					multipliersHistory: Facade.multipliersHistory,
					toFixed: Config.TO_FIXED_VALUES,
					aka: Facade.model.aka,
					b_h: Facade.model.b_h,
					availableBets: Facade.model.availableBets,
					currency: Facade.model.currencyCode,
					presetBets: Facade.model.screenBetsX,
					bet1: Facade.model.minBet,
					bet2: Facade.model.minBet,
					ac1: Facade.model.ac1,
					ac2: Facade.model.ac2,
					dcb: Facade.model.dcb,
					lurl: Facade.model.lobbyURL,
					hurl: Facade.model.historyUrl,
					collect1: Facade.model.currentAutoCollect1,
					collect2: Facade.model.currentAutoCollect2,
					minBet: Facade.model.minBet,
					maxBet: Facade.model.maxBet,
					betStep: Facade.model.betStep,
					minCollect: Facade.model.minCollect,
					maxCollect: Facade.model.maxCollect,
					collectStep: Facade.model.collectStep,
					bc_2h: Facade.model.bc_2h,
					spos: Facade.model.spos,
					np_e: Facade.model.np_e,
				},
			})
		);

		document.dispatchEvent(
			new CustomEvent('setButtonState', {
				detail: {
					fullscreen: {
						visible: !Platform.isIPhone(),
					},
					fullScreenPortraitLabel_TEXT: {
						visible: !Platform.isIPhone(),
					},
				},
			})
		);

		if(Facade.model.spos){
			document.dispatchEvent(new CustomEvent('showinfo', {detail: {value: true}}))
		}
	}

	addListeners() {
		Signals.sessionTimeout.add(this.onSessionTimeout, this);
		Signals.continueBtnClick.add(this.onContinueBtnClick, this);
		Signals.initUI.add(this.show, this);
		Signals.realityCheck.add(this.realityCheckPopup, this);
		Signals.notEnoughMoney.add(this.notEnoughMoneyPopup, this);
		Signals.errorConnection.add(this.errorServer, this);

		document.addEventListener(
			'popupSuccessfullyShown',
			this.onPopupSuccessfullyShown.bind(this)
		);
		document.addEventListener('tap', this.onTap);

		document.body.onkeydown = (e) => {
			if (
				e.key == ' ' &&
				!Facade.model.isAuto &&
				!Facade.model.freespins?.total_amount_given &&
				Facade.isSpaceToSpin
			) {
				if (
					Facade.model.currentState == GameStatesEnum.SPIN_START ||
					Facade.model.currentState == GameStatesEnum.GET_SPIN_RESPONSE ||
					Facade.model.currentState == GameStatesEnum.SPIN_STOP
				) {
					this.onStopClick();
				} else {
					if (!UIBehaviors.getEnableUIDelay()) this.onSpinClick();
					// this.onSpinClick()
				}
			}
		};
	}

	onContinueBtnClick() {
		this.gameEntered = true;
	}

	onTap = (e) => {
		const detail = e.detail;
		let soundName = 'jet_generic';
		let mute = detail.mute ? detail.mute : false;
		clearInterval(this.buttonInterval);

		switch (detail.name) {
			case 'home':
				if (this.shouldRedirect()) {
					Signals.onClose.dispatch();
				}
				break;
			case 'makeBet1_BUTTON':
				soundName = 'jet_button_bet';
				Facade.model.makeBet(1);
				break;

			case 'makeBet2_BUTTON':
				soundName = 'jet_button_bet';
				Facade.model.makeBet(2);
				break;

			case 'setBet1':
				Facade.model.currentBet1 = detail.value;
				break;

			case 'setBet2':
				Facade.model.currentBet2 = detail.value;
				break;

			case 'setCollect1':
				Facade.model.currentAutoCollect1 = detail.value;
				break;

			case 'setCollect2':
				Facade.model.currentAutoCollect2 = detail.value;
				break;

			case 'DisplayMinBetButton1':
				// Facade.model.currentBet2 = Facade.model.screenBets[0]
				Facade.model.minBet1();
				break;

			case 'DisplayMinBetButton2':
				// Facade.model.currentBet2 = Facade.model.screenBets[0]
				Facade.model.minBet2();
				break;

			case 'DisplayMinCollectButton2':
				Facade.model.setMinCollect2();
				break;

			case 'DisplayMinCollectButton1':
				Facade.model.setMinCollect1();
				break;

			case 'maxCollect1_BUTTON':
				Facade.model.setMaxCollect1();
				break;

			case 'maxCollect2_BUTTON':
				Facade.model.setMaxCollect2();
				break;

			case 'maxBet2_BUTTON':
				Facade.model.maxBet2();
				break;

			case 'maxBet1_BUTTON':
				Facade.model.maxBet1();
				break;

			case 'takeWin1':
				this.soundName = 'ui_button_collect_1';
				Signals.gameMessage.dispatch({
					message: 'collect',
					cell: 1,
				});
				break;

			case 'takeWin2':
				this.soundName = 'ui_button_collect_1';
				Signals.gameMessage.dispatch({
					message: 'collect',
					cell: 2,
				});
				break;

			case 'cancel1_BUTTON':
				if (Facade.state === 'lift') {
					this.soundName = 'ui_button_collect_1';
					Signals.gameMessage.dispatch({
						message: 'collect',
						cell: 1,
					});
				} else {
					this.soundName = 'ui_button_cancel_bet_1';
					Signals.gameMessage.dispatch({
						message: 'cancel',
						cell: 1,
					});
				}
				break;

			case 'cancel2_BUTTON':
				if (Facade.state === 'lift') {
					this.soundName = 'ui_button_collect_1';
					Signals.gameMessage.dispatch({
						message: 'collect',
						cell: 2,
					});
				} else {
					this.soundName = 'ui_button_cancel_bet_1';
					Signals.gameMessage.dispatch({
						message: 'cancel',
						cell: 2,
					});
				}
				break;

			case 'setAutoCollect1':
				Facade.model.setAutoCollect1 = detail.value;
				break;

			case 'setAutoCollect2':
				Facade.model.setAutoCollect2 = detail.value;
				break;

			case 'setAutoBet1':
				Facade.model.setAutoBet1 = detail.value;
				Signals.autoBetButtonClicked.dispatch();
				break;

			case 'setAutoBet2':
				Facade.model.setAutoBet2 = detail.value;
				Signals.autoBetButtonClicked.dispatch();
				break;

			case 'sounds_STATE':
				Signals.muteAll.dispatch(detail.value);
				break;
		}

		if (!mute) {
			Facade.soundManager.play(soundName);
		}
	};

	onMuteClick(value) {
		Signals.muteClick.dispatch(value);
	}

	errorServer() {
		const title = Facade.textFactory.getLocalizedText('connectionErrorTitle');
		const message = Facade.textFactory.getLocalizedText('connectionErrorText');
		const button = Facade.textFactory.getLocalizedText('connectionErrorButton');
		console.log('title', title, message);
		this.setBlur();
		const event = new CustomEvent('showPopup', {
			detail: {
				visible: true,
				innerhtml: `
            <div style="background-color: rgba(0, 0, 0, .8);
                padding: 20px;
                width: 400px;
                margin: auto;
                margin-top: -150px;
                margin-left: -150px;
                text-align: center;
                height: 300px;
                color: black;
                border-radius: 20px;
                font-size: 12px">
                <h1 style="text-align: center; color: #FFFFFF">${title}</h1>
                <span style="font-size: 20px; white-space:pre-wrap; text-align: center; color: #FFFFFF">${message}</span>
                <br>
                <br>
                <br>
                <br>
                <div style="display: flex; justify-content: center; flex-wrap: wrap; flex-direction: row";>
                    <button class="Reload" style="text-align: center; padding: 8px 16px;">${button}</button>
                </div>
            </div>
        `,
			},
		});
		document.dispatchEvent(event);
	}

	notEnoughMoneyPopup() {
		this.setBlur();
		const event = new CustomEvent('showPopup', {
			detail: {
				visible: true,
				innerhtml: `
           <div style="background-color: rgba(0, 0, 0, .8);
        padding: 20px;
        width: 300px;
        margin: auto;
        margin-top: -150px;
        margin-left: -150px;
        text-align: center;
        height: 300px;
        color: black;
        border-radius: 20px;
        font-size: 12px">
    <h1 style="text-align: center; color: #FFFFFF">Info</h1>
    <span style="font-size: 20px; text-align: center; color: #FFFFFF">Insufficient Balance</span>
       <br>
    <br>
    <br>
    <br>
    <div style="display: flex; justify-content: center; flex-wrap: wrap; flex-direction: row";>
        <button class="cancelBtn" style="text-align: center">Close</button>
    </div>
    </div>
            `,
			},
		});
		document.dispatchEvent(event);
	}

	onSessionTimeout() {
		const title = new Facade.textFactory.getTextWithStyle(
			'sessionTimeoutTitle'
		);
		const message = new Facade.textFactory.getTextWithStyle('sessionTimeout');
		const reloadThisPage = new Facade.textFactory.getTextWithStyle(
			'reloadThisPage'
		);
		this.setBlur();
		const event = new CustomEvent('showPopup', {
			detail: {
				visible: true,
				innerhtml: `
            <div style="background-color: rgba(0, 0, 0, .8);
        padding: 20px;
        width: 300px;
        margin: auto;
        margin-top: -150px;
        margin-left: -150px;
        text-align: center;
        height: 300px;
        color: black;
        border-radius: 20px;
        font-size: 12px">
    <h1 style="text-align: center; color: #FFFFFF">${title.text}</h1>
    <span style="font-size: 20px; text-align: center; color: #FFFFFF">${message.text}</span>
    <br>
    <br>
    <br>
    <br>
    <div style="display: flex; justify-content: center; flex-wrap: wrap; flex-direction: row";>
        <button class="Reload" style="text-align: center">${reloadThisPage.text}</button>
    </div>
    </div>
            `,
			},
		});
		document.dispatchEvent(event);
	}

	realityCheckPopup(data) {
		if (
			Facade.model.currentState != GameStatesEnum.SHOW_CYCLEWINNINGS &&
			Facade.model.currentState != GameStatesEnum.IDLE &&
			Facade.model.isFreespinsMode
		) {
			return;
		}
		if (Facade.model.isAuto) {
			Signals.stopAutoplay.dispatch(true);
		}
		this.setBlur();
		const buttonsContainer = document.createElement('button');
		buttonsContainer.innerHTML = `
    <div class="buttonsContainer" style="display: flex; justify-content: center; flex-wrap: wrap; flex-direction: row">
    `;

		for (let i = 0; i < data.buttons.length; i++) {
			const button = document.createElement('div');
			button.innerHTML = `<button class=${
				data.buttons[i].text + '_rc'
			} style="border-radius: 20px; height: 50px; width: 100px; text-align: center">${
				data.buttons[i].text
			}</button>`;
			buttonsContainer.appendChild(button);
		}

		const event = new CustomEvent('showPopup', {
			detail: {
				visible: true,
				innerhtml: `
         <div style="background-color: rgba(0, 0, 0, .8);
        padding: 20px;
        width: 300px;
        margin: auto;
        margin-top: -150px;
        margin-left: -150px;
        text-align: center;
        height: 300px;
        color: black;
        border-radius: 20px;
        font-size: 12px">
    <h1 style="text-align: center; color: #FFFFFF">${data.title}</h1>
    <span style="font-size: 20px; text-align: center; color: #FFFFFF;">${data.message}</span>
     <br>
    <br>
    <br>
    <br>
        ${buttonsContainer.innerHTML}
    </div>
            `,
			},
		});

		Facade.isRealityCheckPopupPendingData = null;
		document.dispatchEvent(event);
	}

	onPopupSuccessfullyShown() {
		setTimeout(() => {
			this.reloadBtn = document.getElementsByClassName('Reload')[0];
			this.cancelBtn = document.getElementsByClassName('cancelBtn')[0];
			this.continueBtn = document.getElementsByClassName('Continue_rc')[0];
			this.quitBtn = document.getElementsByClassName('Quit_rc')[0];

			if (this.reloadBtn) {
				this.reloadBtn.addEventListener(
					'click',
					() => {
						window.location.reload(false);
					},
					false
				);
			}

			if (this.quitBtn && Facade.model.lobbyURL) {
				this.quitBtn.addEventListener(
					'click',
					this.quitHandler.bind(this),
					false
				);
			}

			if (this.cancelBtn) {
				this.cancelBtn.addEventListener(
					'click',
					this.hidePopup.bind(this),
					false
				);
			}

			if (this.continueBtn) {
				this.continueBtn.addEventListener(
					'click',
					this.continueHandler.bind(this),
					false
				);
			}
		}, 200);
	}

	quitHandler() {
		window.location.replace(Facade.model.lobbyURL);
	}

	continueHandler() {
		if (Facade.status == 911) {
			Signals.cancelSpin.dispatch(Facade.model.reelsData);
		}
		this.hidePopup();
	}

	hidePopup() {
		this.setUnblur();
		if (this.cancelBtn) {
			this.cancelBtn.removeEventListener(
				'click',
				this.hidePopup.bind(this),
				false
			);
		}
		if (this.continueBtn) {
			this.continueBtn.removeEventListener(
				'click',
				this.hidePopup.bind(this),
				false
			);
		}

		const event = new CustomEvent('closeCustomPopUp', { detail: {} });
		document.dispatchEvent(event);
	}

	setBlur() {
		Config.app.stage.filters = [this.blurFilter];
	}

	setUnblur() {
		Config.app.stage.filters = null;
	}

	shouldRedirect() {
		if (Facade.urlParams.customer === 'egt') {
			this._send('exit');
			return false;
		}

		return true;
	}

	_send(event) {
		const message = { event: event };
		window.parent.postMessage(JSON.stringify(message), '*');
		console.log('::: PostMessageAPI sent', message);
	}
}
